import { Grid, Tabs, Typography, makeStyles } from '@rbx/ui';
import React, { FunctionComponent } from 'react';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import { secondaryNavID } from '@modules/layout/layout/constants/layoutConstants';

type TabItem = {
  id: string;
  label: string;
  path?: string;
};

const useStyles = makeStyles()((theme) => ({
  tabs: {
    position: 'relative',
    bottom: -2.5,
  },
  tabsTitle: {
    paddingRight: theme.spacing(3),
    marginRight: theme.spacing(1),
    marginLeft: -1,
    borderRight: `solid 1px ${theme.palette.components.divider}`,
    position: 'relative',
    top: 2.5,
  },
}));

export interface SecondaryNavbarProps {
  title: string;
  items: TabItem[];
  className?: string;
  selectedId?: string | null;
  defaultId?: string;
}

const SecondaryNavbar: FunctionComponent<React.PropsWithChildren<SecondaryNavbarProps>> = ({
  className,
  items,
  selectedId,
  defaultId,
  title,
}) => {
  const {
    classes: { tabs, tabsTitle },
  } = useStyles();
  return (
    <Grid id={secondaryNavID} alignItems='center' className={className} container wrap='nowrap'>
      <Typography className={tabsTitle} variant='h5'>
        {title}
      </Typography>
      <Tabs
        className={tabs}
        orientation='horizontal'
        scrollButtons='auto'
        variant='standard'
        value={selectedId ?? defaultId}>
        {items.map((item) => {
          const { id, label, path } = item;
          return !path ? null : (
            <DynamicallyRouted.Tab
              tabIndex={0}
              key={id}
              role='link'
              href={path}
              value={id}
              label={label}
            />
          );
        })}
      </Tabs>
    </Grid>
  );
};

export default SecondaryNavbar;
